// extracted by mini-css-extract-plugin
export default {"Loader":"styles_Loader__ZZ5jF","animation":"styles_animation__3RrOz"};